import React from "react";
import { Link } from "react-router-dom";
import { Quote, Star, ArrowRight } from "lucide-react";
import { SITE } from "../../site.config";
import { FEATURED_REVIEWS, TOTAL_REVIEWS } from "../../data/reviews";

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="relative bg-[#0A0A0A] py-24 md:py-32 border-y border-white/10"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-3 mb-4">
            <span className="h-px w-10 bg-cyan-pz" />
            <span className="bebas text-cyan-pz tracking-[0.3em] text-sm">
              CUSTOMER STORIES
            </span>
            <span className="h-px w-10 bg-cyan-pz" />
          </div>
          <h2 className="bebas text-white text-5xl md:text-7xl leading-[0.9] mb-6">
            FROM THE <span className="text-cyan-pz">DRIVERS' SEAT.</span>
          </h2>
          <p className="text-white/60 barlow max-w-2xl mx-auto">
            A few words from real Sunshine Coast locals — every review on this
            page is a verified Google review.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {FEATURED_REVIEWS.slice(0, 6).map((t, i) => (
            <div
              key={`${t.name}-${i}`}
              data-testid={`testimonial-${i}`}
              className="relative bg-black border border-white/10 p-8 hover:border-cyan-pz transition-colors clip-perf flex flex-col"
            >
              <Quote className="w-10 h-10 text-cyan-pz/30 mb-4" />
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, s) => (
                  <Star
                    key={s}
                    className="w-4 h-4 fill-cyan-pz text-cyan-pz"
                  />
                ))}
              </div>
              <p className="text-white/80 barlow text-base leading-relaxed mb-6 flex-1">
                "{t.quote}"
              </p>
              <div className="border-t border-white/10 pt-4">
                <p className="bebas text-white tracking-widest text-lg">
                  {t.name}
                </p>
                <p className="text-cyan-pz/80 text-xs barlow tracking-wider uppercase">
                  {t.service} • via Google
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/reviews"
            data-testid="view-all-reviews-link"
            className="inline-flex items-center gap-3 border border-cyan-pz/40 text-white px-7 py-4 bebas text-lg tracking-widest hover:bg-cyan-pz hover:text-black hover:border-cyan-pz transition-colors clip-tag"
          >
            <Star className="w-4 h-4 fill-cyan-pz text-cyan-pz" />
            VIEW ALL {TOTAL_REVIEWS}+ REVIEWS
            <ArrowRight className="w-4 h-4" />
          </Link>
          <p className="text-white/40 barlow text-xs mt-4">
            Pulled from {SITE.business.name}'s Google Business Profile
          </p>
        </div>
      </div>
    </section>
  );
}
